var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLogout2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    fill: "#B70000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3935 59.7831H31.1334C30.7274 59.7821 30.3985 59.4532 30.3976 59.0472V28.1334C30.3986 27.7274 30.7274 27.3985 31.1334 27.3976H39.3935C40.884 27.3976 42.0923 26.1893 42.0923 24.6988C42.0923 23.2083 40.884 22 39.3935 22H31.1334C27.7476 22.004 25.004 24.7477 25 28.1334V59.0472C25.004 62.433 27.7476 65.1767 31.1334 65.1807H39.3935C40.884 65.1807 42.0923 63.9724 42.0923 62.4819C42.0923 60.9914 40.884 59.7831 39.3935 59.7831Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8134 37.8639L58.8289 30.8848C57.7746 29.831 56.0657 29.8314 55.0119 30.8857C53.9581 31.94 53.9585 33.649 55.0128 34.7027L61.1516 40.8398L36.6988 40.8901C35.2083 40.8901 34 42.0984 34 43.5889C34 45.0794 35.2083 46.2877 36.6988 46.2877L61.2506 46.2428L55.0128 52.4806C53.9972 53.5716 54.0583 55.2793 55.1493 56.2949C56.1862 57.2601 57.7929 57.2593 58.8289 56.2931L65.808 49.314C68.9699 46.1522 68.9699 41.0258 65.8081 37.864L65.808 37.864L65.8134 37.8639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLogout2);
export default __webpack_public_path__ + "static/media/btnLogout2.fe6aadc0bf5b9968fe7cb6df6fd6d05c.svg";
export { ForwardRef as ReactComponent };